<!--
    props
        composers
        editora
    events
        composers_changed
        remove_person

-->
<template v-if="composers_array.length>0">
    <v-flex xs12 md12>
        <v-form>
            <v-expansion-panel v-model="panel" expand color="grey">
                <template v-for="person in composers_array">
                <v-expansion-panel-content
                    
                    class="px-3"
                    
                    :key="person.row_count"
                    v-if="person.pivot.publisher_id == publisher_id"
                >
                    <template v-slot:actions>
                        <v-icon color="primary">$vuetify.icons.expand</v-icon>
                    </template>
                    <template v-slot:header>
                        <div>
                            <strong>
                               Compositor(a) - {{textoCompositorCombinado}}
                                <template
                                    v-if="person.name"
                                >- {{person.name}}</template>
                                <template v-if="person.last_name">{{person.last_name}}</template>
                            </strong>
                        </div>
                    </template>
                    <v-divider></v-divider>

                    <v-layout wrap class="my-1">
                        <v-flex xs12 md5>
                            <v-text-field
                                v-model="person.name"
                                disabled
                                class="purple-input"
                                label="Compositor"
                            />
                        </v-flex>

                        <v-flex xs12 md4 v-if="publisher_id==null">
                            <v-text-field
                                v-model="person.pivot.share"
                                class="purple-input"
                                label="Participação"
                                messages="A % que essa pessoa tem sobre o artista."
                                suffix="%"
                                v-mask="['##.##','###.##']"
                                @keyup="changed_element(person)"
                            />
                        </v-flex>

                        <v-flex xs12 md3>
                            <v-btn
                                dark
                                small
                                color="error"
                                @click="remove_person(person)"
                            >Remover Compositor</v-btn>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                </template>
            </v-expansion-panel>
        </v-form>
    </v-flex>
</template>

      <script>
export default {
    props: {
        composers: Array,
        publisher_id: Number
    },
    data: () => {
        return {
            panel: [true,true],
            composers_array: []
                      
        }
    },
    
    created: function(){
        this.composers_array = this.composers;
        console.log("EDITORA ", this.publisher_id);
    },
    beforeUpdate:function(){
        console.log("listagem, beforeUdate ", this.composers);
        //this.composers_array = this.composers;
    },
    computed:{
        textoCompositorCombinado: function(){
            return this.publisher_id!=null ? "EDITORA" : "INDEPENDENTE";
        }
    },
    watch: {   
         composers: {
            handler: function() {                
                 this.composers_array = this.composers;
            },
            deep: true
        },     
        composers_array: {
            handler: function() {                
                this.$emit("composers_changed", this.composers_array, this.editora);
            },
            deep: true
        }
    },
    methods: {
        remove_person(person) {
            this.$emit("remove_person", person);
        },
        /**
         * Tive que forçar a barra aqui
         */
        changed_element(person){
            this.$emit('composers_changed', this.composers_array);
        }
    }
};
</script>